import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import AddressFields from './AddressFields';
import { CloseIcon } from '../../../../assets/icons';
import { updateUserProfile } from '../../../../services/authApi/userApi';
import { toastNotify } from '../../../../utils/toastNotify';
import { changeAddressData } from '../../../../store/reducer/accountSlice';

const EditAddress = (props) => {
  const [address, setAddress] = useState();
  const [aptNumber, setAptNumber] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState(undefined);
  const [stateName, setStateName] = useState(undefined);
  const [zipCode, setZipCode] = useState();
  const [country, setCountry] = useState('unitedstates');
  const [isEdit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { addressData } = props;
  const dispatch = useDispatch();
  const [arrowUp, setArrowUp] = useState(false);
  const [isChangedValue, setIsChangedValue] = useState(false);

  useEffect(() => {
    handleSetDefaultData();
  }, [addressData]);

  const handleSetDefaultData = () => {
    if (Object.keys(addressData).length > 0) {
      let { residentialAdd, apartmentNumber, city, zipCode } = addressData;
      form.setFieldsValue({
        address: residentialAdd,
        aptNumber: apartmentNumber,
        city: city,
        state: addressData.state,
        zipcode: zipCode,
      });
      setEdit(true);
    }
  };

  const onEditAddressSubmit = async (values) => {
    setLoading(true);
    const { address, aptNumber, city, zipcode } = values;
    const addressFormData = {
      address: {
        residentialAdd: address,
        city: city,
        state: state ? state?.toString() : addressData?.stateId?.toString(),
        zipCode: zipcode,
      },
    };
    if (aptNumber) addressFormData['address']['apartmentNumber'] = aptNumber;
    try {
      const resp = await updateUserProfile(addressFormData);
      if (!resp.isError) {
        dispatch(
          changeAddressData({
            ...addressFormData.address,
            stateId: state ? state?.toString() : addressData?.stateId?.toString(),
            state: stateName ? stateName : addressData.state,
          })
        );
        props.setClose();
        toastNotify('success', 'Address updated successfully.');
      } else {
        toastNotify('error', resp?.message || 'Failed to update address. Please try again.');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message || 'Failed to update address. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCheckChanges = (values) => {
    if (
      values?.address !== addressData?.residentialAdd ||
      values?.aptNumber !== addressData?.apartmentNumber ||
      values?.city !== addressData?.city ||
      (state && Number(values?.state) !== Number(addressData?.stateId)) ||
      values?.zipcode !== addressData?.zipCode
    ) {
      setIsChangedValue(true);
    } else {
      setIsChangedValue(false);
    }
  };

  return (
    <Modal
      className='account__modal'
      open={props.setOpen}
      onCancel={() => {
        handleSetDefaultData();
        props.setClose();
      }}
      width={524}
      footer={false}
      closeIcon={<CloseIcon />}
      centered
    >
      <h4 className='mb-32 account__modal__title'>Edit your address</h4>
      <Form
        onFieldsChange={() => handleCheckChanges(form.getFieldValue())}
        onSelect
        name='editAddressForm'
        form={form}
        onFinish={onEditAddressSubmit}
        autoComplete='off'
      >
        <AddressFields
          addressLabel='Residential address'
          addressRequiredMessage='Please enter Residential address'
          addressInvalidMessage='Address must be a valid residential address.  P.O. Box addresses are not allowed'
          addressLengthMessage='Please provide a valid residential address value. Residential address length should be between 2 and 49.'
          aptNumberInvalidMessage='Address must be a valid residential address. P.O. Box addresses are not allowed'
          countryAnchorId='country-anchor'
          address={address}
          setAddress={setAddress}
          aptNumber={aptNumber}
          setAptNumber={setAptNumber}
          city={city}
          setCity={setCity}
          state={state}
          setState={setState}
          setStateName={setStateName}
          zipCode={zipCode}
          setZipCode={setZipCode}
          country={country}
          setCountry={setCountry}
          isEdit={isEdit}
          arrowUp={arrowUp}
          setArrowUp={setArrowUp}
        />
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <Form.Item className='mb-0'>
              <Button
                className='w-100'
                onClick={() => {
                  props.setClose();
                  handleSetDefaultData();
                }}
              >
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={24} sm={12}>
            <Form.Item className='mb-0' shouldUpdate>
              {() => (
                <Button
                  className='w-100'
                  type='primary'
                  htmlType='submit'
                  loading={loading}
                  disabled={
                    // !form.isFieldsTouched() ||
                    !!form.getFieldsError().filter(({ errors }) => errors.length).length || !isChangedValue
                  }
                >
                  Save
                </Button>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditAddress;
